module.exports = __webpack_public_path__ + "img/eib.6d8f6e38.png";